<google-map-extended (onReady)="onGoogleMapInited($event)"> </google-map-extended>
